"use client";

import { useEffect } from "react";

/** Registers the minimal PWA service worker on mount. No-ops in unsupported browsers. */
export default function ServiceWorkerRegistrar() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        // SW registration failure is non-fatal; app functions normally without it.
      });
    }
  }, []);

  return null;
}
